//LIBRARIES
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

//COMPONENTS
import ToggleSwitch from 'components/ui/ToggleSwitch';
import Spacer from 'components/ui/Spacer';
import Form from 'components/ui/Form';
import TextButton from 'components/ui/Buttons/TextButton';

//ACTIONS
import { resetUserCredentials } from 'actions/landlordUserActions';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';

const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  margin: 0px;
`;

const Description = styled.p`
  line-height: 15px;
`;

const Button = styled(TextButton)`
  padding: 0;
`;

const AdminUser = ({ values, setFieldValue, user, resetUserCredentials, formName }) => {
  return (
    <Fragment>
      <Spacer mb={1}>
        <Form.Item>
          <ToggleSwitch
            name="admin"
            titleSize="18px"
            alertText={`${getTranslatedString('landlordPortal.users.form.warning')}: `}
            isChecked={values['admin']}
            onChange={value => setFieldValue('admin', value)}
          />
        </Form.Item>
        {formName !== 'add_user_form' && (
          <Form.Item style={{ marginTop: '1rem' }}>
            <Title>{getTranslatedString('landlordPortal.userForm.resetCredentials')}</Title>
            <Description>
              {getTranslatedString('landlordPortal.userForm.resetThisUser')}
            </Description>
            <Button onClick={() => resetUserCredentials(user.user_id, user.user_type)}>
              {getTranslatedString('landlordPortal.userForm.resetCredentials')}
            </Button>
          </Form.Item>
        )}
      </Spacer>
    </Fragment>
  );
};

export default connect(
  state => ({
    user: state.landlordUsers.user,
  }),
  {
    resetUserCredentials,
  }
)(AdminUser);
